import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

import { ConfirmSubmissionDialogModel } from './model/confirm-submission-dialog.model';

/**
 * Component for the selected product pop-up.
 */
@Component({
  selector: 'broker-confirm-submission-dialog',
  templateUrl: './confirm-submission-dialog.component.html'
})
export class ConfirmSubmissionDialogComponent {
  /**
   * Emits an event when the navigation bar back button click event occurs.
   */
  @Output() navigationBarBackButtonClickEvent: EventEmitter<void> = new EventEmitter<void>();

  /**
   * Emits an event when the navigation bar next button click event occurs.
   */
  @Output() navigationBarNextButtonClickEvent: EventEmitter<void> = new EventEmitter<void>();

  /**
   * The next request pending state.
   */
  nextRequestPending = false;

  /**
   * The next request error state.
   */
  nextRequestError = false;

  /**
   * The button disable state.
   */
  isButtonDisabled = false;

  constructor(@Inject(MAT_DIALOG_DATA) public data: ConfirmSubmissionDialogModel) {}

  /**
   * Handles the navigation bar back button click event.
   */
  handleNavigationBarBackButtonClickEvent(): void {
    this.navigationBarBackButtonClickEvent.emit();
  }

  /**
   * Handles the navigation bar next button click event.
   */
  handleNavigationBarNextButtonClickEvent(): void {
    this.navigationBarNextButtonClickEvent.emit();
  }
}
